import React from 'react'
import { StyledUserRegistrationButton } from './styled'

export const UserRegistrationButton: React.FC = () => {
  const handleLoginClick = () => {
    location.href = '/login'
  }
  const handleSignupClick = () => {
    location.href = '/signup'
  }
  return (
    <StyledUserRegistrationButton
      onSignupButtonClick={handleSignupClick}
      onLoginButtonClick={handleLoginClick}
    />
  )
}
